import React, { Component, Fragment } from "react";
import Header from "../Header";
import { Link } from "react-router-dom";
import AppContext from "../../../contexts/AppContext";
import { records, updateProfileData } from "../../../services/userDatails";
export class ProfileSettings extends Component {
    state = {
        profile_URL: this.context.state.user.url,
        public_profile: true,
		full_URL: this.context.state.user.fullurl,
		copy:"Copy"
    };

    handleInputChange = e => {
        this.setState({ [e.target.id]: e.target.value });
    };
	
	Copy = () => {
		this.setState({ copy: "Copied" });
		navigator.clipboard.writeText(this.state.full_URL);
	};

    handleCheckBoxChange = e => {
        const toggled = this.state[e.target.id] === "true" ? "false" : "true";
        this.setState({ [e.target.id]: toggled });
    };
    componentDidMount() {
        if (this.context.state.user.change_profile_flag === "false") {
            this.context.state.urlUpdatedOnce();
        }
        records()
            .then(res => {
                const { link, public: public_profile } = res.data;
                this.setState({
                    profile_URL: link,
                    public_profile
                });
            })
            .catch(err => {
                this.context.state.handelError(err);
            });
    }
    updateProfileURL = () => {
        if (
            this.context.state.user.change_profile_flag === "true" &&
            this.context.state.isUrlUpdatedOnce === false
        ) {
            updateProfileData({
                key: "url",
                value: this.state.profile_URL
            })
                .then(res => {
                    this.context.state.updateUser(res.data);
                    this.context.state.urlUpdatedOnce();
                    this.context.state.showCodeMessage(
                        "Your Profile URL has been updated!",
                        "success"
                    );
                })
                .catch(error => {
                    this.context.state.showCodeMessage(
                        "Something wen wrong, please try again!",
                        "error"
                    );
                });
        }
    };
    updatePublicProfile = () => {
        setTimeout(() => {
            updateProfileData({
                key: "public",
                value: this.state.public_profile
            })
                .then(res => {
                    this.context.state.showCodeMessage(
                        "Your Profile status has been updated!",
                        "success"
                    );
                })
                .catch(error => {
                    this.context.state.showCodeMessage(
                        "Something went wrong!",
                        "error"
                    );
                });
        });
    };
    render() {
		return (
		    <Fragment>               
                <div className="header">
                    <div className="header-body">
                        <div className="row align-items-center">
                            <div className="col">
                                <h1 className="header-title">
                                    Settings
                                </h1>
                                <h6 className="header-pretitle">
                                    MANAGE THE SETTINGS AND
                                    VISIBILITY OF YOUR WRITER
                                    PORTFOLIO.
	                            </h6>
                            </div>
                            <div className="col-auto">
							    <a className="relative view_my_portfolio" href={this.state.full_URL} target="_blank">View my portfolio <i className="fe fe-arrow-right"></i></a>
							</div>
                        </div>
                    </div>
                </div>

                <div className="row">
				    <div className="col-md-6 col-12">
					    <div className="form-group m-form__group">
                            <label
                                className="mb-1"
                                htmlFor="share_portfolio"
                            >
                                Share Portfolio
                            </label>
                            <div className="input-group">    
							<input
                                    id="share_portfolio"
                                    type="text"
                                    className="form-control"
                                    value={this.state.full_URL}
                                    readOnly="true"
									
							/> 
							    <span className="input-group-btn">
                                    <button onClick={this.Copy} className="btn btn-primary" type="button">{this.state.copy}</button>
                                </span>
							</div>
                        </div>
					</div>
					<div className="col-md-6 col-12">
					    <div className="share pt-md-4 pt-3">
                            <ul className="d-flex align-items-center">
                                <li>
								    <a href={`https://www.facebook.com/sharer/sharer.php?u=${this.state.full_URL}&utm_source=portfolio&amp;utm_medium=share&amp;utm_campaign=facebook`} target="_blank">
									    <i className="fe fe-facebook" aria-hidden="true"></i>
									</a>
								</li>
                                <li>
								    <a href={`https://twitter.com/intent/tweet?text=${this.state.full_URL}?utm_source=portfolio&amp;utm_medium=share&amp;utm_campaign=twitter via @ProWriterHQ`} target="_blank">
								        <i className="fe fe-twitter" aria-hidden="true"></i>
									</a>
								</li>
                                <li>
								    <a href={`https://www.linkedin.com/shareArticle?mini=true&amp;url=${this.state.full_URL}?utm_source=portfolio&amp;utm_medium=share&amp;utm_campaign=linkedin`} target="_blank">
									    <i className="fe fe-linkedin" aria-hidden="true"></i>
									</a>
								</li>
                            </ul>
                        </div>
					</div>
                    <div className="col-12 col-md-6 mt-4">
                        <div className="row">
                            <div className="col-12 col-md-12">
                                <div className="form-group m-form__group">
                                    <label
                                        className="mb-1"
                                        htmlFor="profile_URL"
                                    >
                                        Manage Portfolio URL
                                    </label>
                                    <input
                                        onChange={
                                            this
                                                .handleInputChange
                                        }
                                        readOnly={
                                            this.context.state
                                                .isUrlUpdatedOnce
                                        }
                                        value={
                                            this.state
                                                .profile_URL
                                        }
                                        id="profile_URL"
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                                <button
                                    id="profileButton"
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={
                                        this.updateProfileURL
                                    }
                                    disabled={
                                        this.context.state
                                            .isUrlUpdatedOnce
                                    }
                                >
                                    Update url
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 mt-4">
                        <div className="form-group">
                            <label className="mb-1">
                                Profile URL
                            </label>
                            <small className="form-text text-muted">
                                <strong> Please Note </strong>:
                                You are only able to change your
                                ProWriter username once. Do not
                                add any unusual capitalization,
                                punctuation, or characters.
                            </small>
                        </div>
                    </div>
                </div>

                <hr className="mt-4 mb-5 " />
                <div className="row">
                    <div className="col-12 col-md-6">
                        <div className="form-group">
                            <label className="mb-1">
                                Public profile
                            </label>
                            <div className="row">
                                <div className="col-auto">
                                    <div className="custom-control custom-switch">
                                        <input
                                            onChange={
                                                this
                                                    .handleCheckBoxChange
                                            }
                                            onClick={
                                                this
                                                    .updatePublicProfile
                                            }
                                            checked={
                                                this.state
                                                    .public_profile ===
                                                "true"
                                            }
                                            type="checkbox"
                                            className="custom-control-input"
                                            id="public_profile"
                                        />
                                        <label
                                            className="custom-control-label"
                                            htmlFor="public_profile"
                                        ></label>
                                    </div>
                                </div>
                                <div className="col ml-n2">
                                    <small className="text-muted">
                                        Your portfolio is {this.state.public_profile ==="true" ? "public" : "private"}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <small className="text-muted">
                            Making your profile public means
                            that anyone on the ProWriter network
                            will be able to find you.
                        </small>
                    </div>
                </div>
            </Fragment>
        );
    }
}

ProfileSettings.contextType = AppContext;
export default ProfileSettings;



// WEBPACK FOOTER //
// ./src/components/writer/settings/ProfileSettings.js